import { combineReducers } from 'redux';
import util from '../util';
import { CURRENT_USER_PERMISSIONS, USER_ROLES } from './actionTypes';

export default combineReducers({
  currentUserPermissions: util.requestReducer(CURRENT_USER_PERMISSIONS),
  userRoles: util.requestReducer(USER_ROLES),
});
